enum FormFieldTypeIdEnum {
  Select = '0dd29d42-a6a5-11de-a2f2-222256d89593',
  Textarea = '023f09ac-1445-4bcb-b8fa-ab49f33bd046',
  Text = '3f92e01b-29e2-4a30-bf33-9df5580ed52c',
  Date = 'f8b4c3b8-af28-11de-9dd8-ef5956d89593',
  RadioGroup = '903df9b0-a78c-11de-9fc1-db7a56d89593',
  CheckboxGroup = 'fab43f20-a6bf-11de-a28f-9b5755d89593',
  Checkbox = 'd5c0c390-ae9a-11de-a69e-666455d89593',
  Upload = '84a17cf8-b711-46a6-9840-0e4a072ad000',
}

export default FormFieldTypeIdEnum;
